module.exports = __webpack_public_path__ + "static/media/winchestival-1.2500cae8.svg";